import toDate from "../toDate/index.mjs";
import requiredArgs from "../_lib/requiredArgs/index.mjs";
function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}
export {
  differenceInMilliseconds as default
};
